// @flow
import React from 'react';
import Slot from 'shared/editor/Slot';
import withThemeProvider from 'shared/hoc/withThemeProvider';
import type { $Slot } from '../../../types';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';
import Box from '@ff/ui/Box';
import { styled } from '@ff/ui';

type TemplateSettings = {
  region: string,
  page_title: string,
  last_updated: string,
}

type Props = {
  slots: $Slot[],
  templateSettings: TemplateSettings,
  widgetPresets: Array,
  path: string
}

function CenterText({ slots, templateSettings, widgetPresets, path }: Props) {
  return (
    <Box>
      <Menu>
        <Slot id={'menu-bar'} slots={slots} widgetPresets={widgetPresets} path={path} />
      </Menu>
      <Content>
        <Title>
          {templateSettings.page_title}
        </Title>
        <Timestamp>
          {templateSettings.region === 'US' ?
            <span>LAST UPDATE: </span> :
            <span>最新更新：</span>
          }
          {templateSettings.last_updated}
        </Timestamp>
        <Slot id={'content'} slots={slots} widgetPresets={widgetPresets} path={path} />
      </Content>
      <Footer id="footer">
        <Slot id={'footer'} slots={slots} widgetPresets={widgetPresets} path={path} />
      </Footer>
    </Box>
  );
}

const Menu = styled(Box)({
  width: '100%',
  position: 'relative',
  zIndex: '10'
});

const Content = styled(Box)({
  width: '100%',
  maxWidth: '620px',
  margin: 'auto',
  padding: '160px 15px 100px',
  fontFamily: FONT_FAMILY_ROBOTO,
  '& article': {
    padding: '0',
    '&> *': {
      width: 'auto'
    }
  },
  '@media(max-width: 960px)': {
    maxWidth: '100%',
    paddingTop: '70px'
  }
});

const Title = styled(Box)({
  fontSize: '40px',
  fontWeight: '300',
  letterSpacing: '1px',
  lineHeight: '1.2em',
  marginBottom: '18px',
  textAlign: 'center'
});

const Timestamp = styled(Box)({
  textAlign: 'center',
  fontSize: '14px',
  lineHeight: '1.2',
  letterSpacing: '.1em',
  textTransform: 'uppercase',
  marginBottom: '36px'
});

const Footer = styled(Box)({
  width: '100%'
});
Footer.defaultProps = { as: 'footer' };

export default withThemeProvider(CenterText);
